import Apple from "./Apple";
import Behance from "./Behance";
import BehanceFull from "./BehanceFull";
import Facebook from "./Facebook";
import Figma from "./Figma";
import Instagram from "./Instagram";
import LinkedIn from "./LinkedIn";
import Nextjs from "./Nextjs";
import Nike from "./Nike";
import NPM from "./NPM";
import Threads from "./Threads";
import ThreadsFill from "./ThreadsFill";
import Typescript from "./Typescript";
import Vercel from "./Vercel";
import VercelFull from "./VercelFull";
import WhatsApp from "./WhatsApp";
import Wordpress from "./Wordpress";
import X from "./X";
import YouTube from "./YouTube";

export * from "./Apple";
export * from "./Behance";
export * from "./BehanceFull";
export * from "./LinkedIn";
export * from "./YouTube";
export * from "./Facebook";
export * from "./Instagram";
export * from "./Nextjs";
export * from "./Figma";
export * from "./NPM";
export * from "./Nike";
export * from "./X";
export * from "./WhatsApp";
export * from "./Typescript";
export * from "./Threads";
export * from "./ThreadsFill";
export * from "./Vercel";
export * from "./VercelFull";
export * from "./Wordpress";

export const Brands = {
  X,
  Apple,
  Behance,
  BehanceFull,
  Figma,
  LinkedIn,
  NPM,
  Nextjs,
  YouTube,
  Facebook,
  Instagram,
  Threads,
  ThreadsFill,
  Nike,
  Vercel,
  VercelFull,
  Wordpress,
  WhatsApp,
  Typescript,
};
